<template>
  <div class="lineChart">
    <div class="fl">
      <img
        src="../../../assets/images/newIcon/vip_lifecycle_icon@2x.png"
        alt=""
      />
      <span></span><b style="font-weight:500;">注册用户LTV {{ LTV }} 分析</b>
    </div>
    <span class="text">{{ date }}</span>
    <div class="two-box">
      <div>
        <span style="font-size:14px;">初始人数</span>
        <h2 class="bigsize bluecolor">
          1,360<span class="small bluecolor" style="font-weight:500;">人</span>
        </h2>
      </div>
      <div class="div2">
        <span style="font-size:14px;"> LTV {{LTV}} 总营收</span>
        <h2 class="bigsize bluecolor">
          1,360<span class="small bluecolor" style="font-weight:500;">元</span>
        </h2>
      </div>
    </div>
    <div style="margin-top:20px;" :id="lid"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
export default {
  props: ["lid", "LTV", "date","type"],
  data() {
    return {
      data1:[
        { data: "LTV当天", name: "消费金额", val: 120 },
        { data: "LTV1",    name: "消费金额", val: 750 },
        { data: "LTV2",    name: "消费金额", val: 270 },
        { data: "LTV3",    name: "消费金额", val: 280 },
        { data: "LTV4",    name: "消费金额", val: 850 },
        { data: "LTV5",    name: "消费金额", val: 150 },
        { data: "LTV6",    name: "消费金额", val: 700 },
        { data: "LTV7",    name: "消费金额", val: 140 },
      ],
      data2:[
        { data: "LTV当天", name: "消费金额", val: 120 },
        { data: "LTV1",    name: "消费金额", val: 750 },
        { data: "LTV2",    name: "消费金额", val: 270 },
        { data: "LTV3",    name: "消费金额", val: 280 },
        { data: "LTV4",    name: "消费金额", val: 850 },
        { data: "LTV5",    name: "消费金额", val: 150 },
        { data: "LTV6",    name: "消费金额", val: 700 },
        { data: "LTV7",    name: "消费金额", val: 140 },
        { data: "LTV15",   name: "消费金额", val: 120 }
      ],
      data3:[
        { data: "LTV当天", name: "消费金额", val: 120 },
        { data: "LTV1",    name: "消费金额", val: 750 },
        { data: "LTV2",    name: "消费金额", val: 270 },
        { data: "LTV3",    name: "消费金额", val: 280 },
        { data: "LTV4",    name: "消费金额", val: 850 },
        { data: "LTV5",    name: "消费金额", val: 150 },
        { data: "LTV6",    name: "消费金额", val: 700 },
        { data: "LTV7",    name: "消费金额", val: 140 },
        { data: "LTV15",   name: "消费金额", val: 120 },
        { data: "LTV30",   name: "消费金额", val: 130 },
      ],
      data4:[
        { data: "LTV当天", name: "消费金额", val: 120 },
        { data: "LTV1",    name: "消费金额", val: 750 },
        { data: "LTV2",    name: "消费金额", val: 270 },
        { data: "LTV3",    name: "消费金额", val: 280 },
        { data: "LTV4",    name: "消费金额", val: 850 },
        { data: "LTV5",    name: "消费金额", val: 150 },
        { data: "LTV6",    name: "消费金额", val: 700 },
        { data: "LTV7",    name: "消费金额", val: 140 },
        { data: "LTV15",   name: "消费金额", val: 120 },
        { data: "LTV30",   name: "消费金额", val: 130 },
        { data: "LTV60",   name: "消费金额", val: 130 },
        { data: "LTV90",   name: "消费金额", val: 130 },
      ]
    };
  },
  computed:{
    data(){
      if(this.type == 1){
      return this.data1
    }else if(this.type == 2){
      return this.data2
    }else if(this.type == 3){
      return this.data3
    }else if(this.type == 4){
      return this.data4
    }
    }
  },
  mounted() {
    this.lineChart();
  },
  methods: {
    lineChart() {
      const chart = new this.$chart({
        container: this.lid,
        autoFit: true,
        height: 320,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(this.data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });


      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: false,
      });
      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });
  chart.legend()
      chart
        .line()
        .position("data*val")
        .color('name')
        .shape("smooth");

      // chart.point().position("data*val")
      // .shape("circle");

      chart.render();
    },
  },
};
</script>

<style lang="less" >
.lineChart {
  .fl {
    font-size: 16px;
    display: flex;
    b {
      margin-left: 6px;
    }
    img {
      width: 24px;
    }
  }
  .text {
    display: block;
    margin-left: 12px;
    color: #333;
    font-size: 12px;
    line-height: 24px;
    margin-top: 10px;
  }
  .two-box {
    margin-top: 10px;
    display: flex;
    div {
      margin-left: 20px;
      &.div2 {
        margin-left: 120px;
      }
    }
  }
  .chartbox {
    height: 300px !important;
  }
  .bigsize {
    font-size: 43px !important;
  }
  .small {
    font-size: 16px !important;
  }
  .bluecolor {
    color: #327eff !important;
  }
}
</style>